// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Breadcrumb from "../../components/breadcrumb/index";
// import Modal from "react-modal";
// import Layouts from "../../layouts/layouts";
// import Select from "react-select";

// Modal.setAppElement("#root");

// export default function Create_companysupport() {
//   const title = "Add Support Email";
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     companyName: "",
//     emails: "",
//   });

//   const [errors, setErrors] = useState({});

//   const brad = [
//     {
//       name: "Home",
//     },
//     {
//       name: title,
//     },
//   ];
//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.companyName) {
//       newErrors.companyName = "Company name is required.";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const onChangeHandler = (event) => {
//     const { name, value } = event.target;

//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));
//   };

//   const onSubmitHandler = async (event) => {
//     event.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     const token = localStorage.getItem("token");
//     if (!token) {
//       console.error("No token found");
//       return;
//     }

//     const data = new FormData();
//     data.append("companyName", formData.companyName);
//     data.append("emails", formData.emails);
//     for (let [key, value] of data.entries()) {
//       console.log(`${key}: ${value}`);
//     }
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}/api/v4/company-email`,
//         data,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       console.log("Response data:", response.data);

//       if (response.status === 201) {
//         navigate("/companysupport");
//       } else {
//         console.error("Submission failed:", response.statusText);
//       }
//     } catch (error) {
//       //   console.error("Error:", error);

//       console.error("Error:", error.response ? error.response.data : error);
//     }
//   };

//   return (
//     <>
//       <Layouts />
//       <div className="container-fluid">
//         <Breadcrumb title={title} brad={brad} />
//         <form
//           className="card"
//           style={{ borderTop: "2px solid #4723d9" }}
//           onSubmit={onSubmitHandler}
//         >
//           <div className="card-header d-flex justify-content-between border-bottom pb-1">
//             <div className="">{title}</div>
//             <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
//               Back
//             </div>
//           </div>
//           <div className="card-body">
//             <div className="row justify-content-center">
//               <div className="col-md-6 mt-3">
//                 <label htmlFor="companyName">
//                   <b> Company Name *</b>
//                 </label>
//                 <input
//                   type="text"
//                   placeholder="Company Name"
//                   className="form-control"
//                   name="companyName"
//                   onChange={onChangeHandler}
//                   value={formData.companyName || ""}
//                 />
//                 {errors.companyName && (
//                   <p className="text-danger">{errors.companyName}</p>
//                 )}
//               </div>

//               <div className="col-md-6 mt-3">
//                 <label htmlFor="companyName">
//                   <b> Email *</b>
//                 </label>
//                 <input
//                   type="text"
//                   placeholder="Enter Email"
//                   className="form-control"
//                   name="emails"
//                   onChange={onChangeHandler}
//                   value={formData.emails || ""}
//                 />
//                 {errors.emails && (
//                   <p className="text-danger">{errors.emails}</p>
//                 )}
//               </div>
//             </div>
//             <button type="submit" className="btn btn-primary btn-sm mt-3">
//               Add Emails
//             </button>
//           </div>
//         </form>
//       </div>
//     </>
//   );
// }

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";

Modal.setAppElement("#root");

export default function Create_companysupport() {
  const title = "Add Support Email";
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    companyName: "",
    emails: [],
  });

  const [emailInput, setEmailInput] = useState("");
  const [errors, setErrors] = useState({});

  const brad = [{ name: "Home" }, { name: title }];

  const validateForm = () => {
    const newErrors = {};

    if (!formData.companyName) {
      newErrors.companyName = "Company name is required.";
    }
    if (!formData.emails || formData.emails.length === 0) {
      newErrors.emails = "At least one email is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    // ✅ Create a plain JSON object
    const payload = {
      companyName: formData.companyName,
      emails: formData.emails,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v4/company-email`,
        payload, // ✅ No FormData
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        navigate("/companysupport");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error);
    }
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div>{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>

          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="companyName">
                  <b>Company Name *</b>
                </label>
                <input
                  type="text"
                  placeholder="Company Name"
                  className="form-control"
                  name="companyName"
                  onChange={onChangeHandler}
                  value={formData.companyName || ""}
                />
                {errors.companyName && (
                  <p className="text-danger">{errors.companyName}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="emails">
                  <b>Emails *</b>
                </label>
                <div className="input-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter email and click +"
                    value={emailInput}
                    onChange={(e) => setEmailInput(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => {
                      if (
                        emailInput &&
                        /\S+@\S+\.\S+/.test(emailInput) &&
                        !formData.emails.includes(emailInput)
                      ) {
                        setFormData((prev) => ({
                          ...prev,
                          emails: [...prev.emails, emailInput],
                        }));
                        setEmailInput("");
                      }
                    }}
                  >
                    +
                  </button>
                </div>
                {errors.emails && (
                  <p className="text-danger">{errors.emails}</p>
                )}

                <div className="mt-2">
                  {formData.emails.map((email, idx) => (
                    <span
                      key={idx}
                      className="badge bg-secondary me-1"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          emails: prev.emails.filter((_, i) => i !== idx),
                        }))
                      }
                    >
                      {email} &times;
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Emails
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
